import {
  Filters,
  IndicatorTissotFilters,
  IndicatorTissotFiltersBooleanValues,
  IndicatorTissotFiltersValues,
} from '../indicator-types';

/**
 * Initialise les filtres avec les valeurs par défaut si elles ne sont pas définies
 */
export const toIndicatorTissotFilters = (filters: Filters): IndicatorTissotFilters => {
  return {
    // Multi-select filters
    gender: filters.gender || IndicatorTissotFiltersValues.gender.map((d) => d.value),
    contractNature: filters.contractNature || IndicatorTissotFiltersValues.contractNature.map((d) => d.value),
    time_modality: filters.time_modality || IndicatorTissotFiltersValues.time_modality.map((d) => d.value),
    nationality: filters.nationality || IndicatorTissotFiltersValues.nationality.map((d) => d.value),
    change: filters.change || IndicatorTissotFiltersValues.change.map((d) => d.value),
    csp: filters.csp || IndicatorTissotFiltersValues.csp.map((d) => d.value),
    tranche_age: filters.tranche_age || IndicatorTissotFiltersValues.tranche_age.map((d) => d.value),
    anciennete: filters.anciennete || IndicatorTissotFiltersValues.anciennete.map((d) => d.value),
    motif_fin: filters.motif_fin || IndicatorTissotFiltersValues.motif_fin.map((d) => d.value),
    motif_arret: filters.motif_arret || IndicatorTissotFiltersValues.motif_arret.map((d) => d.value),
    // Boolean filters
    hired: filters.hired || IndicatorTissotFiltersBooleanValues.hired,
    disabled_worker: filters.disabled_worker || IndicatorTissotFiltersBooleanValues.disabled_worker,
    promoted: filters.promoted || IndicatorTissotFiltersBooleanValues.promoted,
    has_activite: filters.has_activite || IndicatorTissotFiltersBooleanValues.has_activite,
    present_in_month: filters.present_in_month || IndicatorTissotFiltersBooleanValues.present_in_month,
    present_end_of_month: filters.present_end_of_month || IndicatorTissotFiltersBooleanValues.present_end_of_month,
    present_all_month: filters.present_all_month || IndicatorTissotFiltersBooleanValues.present_all_month,
    last_contract: filters.last_contract || IndicatorTissotFiltersBooleanValues.last_contract,
    leaving: filters.leaving || IndicatorTissotFiltersBooleanValues.leaving,
  };
};
